export default "__VITE_ASSET__3954213f__"